import {HORACHECKIN} from "../Constantes";

export const obtenerFechaEstandarCheckIn = (dateTime) => {

    let fecha = new Date(dateTime)
    let fechaStandar = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), HORACHECKIN).getTime()

    return fechaStandar
}